import React from "react";
import {
  Box,
  Button,
  Heading,
  Hidden,
  IconButton,
  Inline,
} from "@origin-digital/ods-core";
import { IconChevronLeft, SvgIcon } from "@origin-digital/ods-icons";
import { usePageTitleSection } from "./usePageTitleSection";

export const PageTitleSection = () => {
  const {
    featureFlags,
    backIconButtonProps,
    headingProps,
    editProjectButtonProps,
  } = usePageTitleSection();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      data-id="pageTitleSection.root"
    >
      <Box
        display="flex"
        gap="small"
        alignItems="center"
        data-id="pageTitleSection.headingBox"
      >
        <IconButton noIconPadding aria-label="Go back" {...backIconButtonProps}>
          <IconChevronLeft size="xxsmall" variant="solid" />
        </IconButton>
        <Heading variant="h3" {...headingProps} />
      </Box>
      {featureFlags.enableEditProject && (
        <Button
          size="small"
          variant="text"
          color="secondaryB"
          noTextPadding
          icon={
            <SvgIcon color="inherit">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
            </SvgIcon>
          }
          {...editProjectButtonProps}
        >
          <Inline>
            <Hidden below="lg">Edit project</Hidden>
            <Hidden above="lg">Edit</Hidden>
          </Inline>
        </Button>
      )}
    </Box>
  );
};
